import * as React from "react";
import { forwardRef } from "react";
const SvgTrapezoid = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 14, viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.90963 2.14673C5.05659 1.75755 5.42914 1.5 5.84515 1.5H14.5885C15.0182 1.5 15.3998 1.77446 15.5365 2.18178L18.5575 11.1818C18.775 11.8297 18.2929 12.5 17.6095 12.5H2.44655C1.74736 12.5 1.26402 11.8008 1.51103 11.1467L4.90963 2.14673Z", stroke: "#2B2B35", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgTrapezoid);
export { ForwardRef as ReactComponent };
